import { useDispatch, useSelector } from "react-redux";
import { Modal3Options } from "../../../_UI/Components/Modal3Options";
import { EXTERNAL_AUTH_CONNECTIONS } from "../screens/ClientsScreen";
import { Modes } from "../../../_statics/CRUDStatics";
import { clientReducerActions } from "../../../_services/store";
import { initialConnectedAuthData } from "../services/clients.reducer";
import {
    deleteConnectedAuthDataForClient,
    prepareAuthDataOnboarding,
    submitEditConnectedAuthData,
    updateConnectedAuthDataForClient,
} from "../services/clients.actions";
import { AuthDataType } from "../../../_statics/AuthDataType";
import { AuthDataStatus } from "../../../_statics/AuthDataStatus";
import { useEffect, useMemo, useState } from "react";
import ConnectedAuthDataInput from "./ConnectedAuthDataInput";

export default function ClientPaymentConnectionSetupModal(props) {
    const clientReducer = useSelector((state) => state.client);
    const dispatch = useDispatch();

    const [connectedAuthErrorForClient, setConnectedAuthErrorForClient] = useState(null);

    const cancelEditConnectedAuthData = () => {
        dispatch(clientReducerActions.setEditConnectedAuthDataMode(null));
        dispatch(clientReducerActions.setEditConnectedAuthData(initialConnectedAuthData));
        dispatch(clientReducerActions.toggleEditConnectedAuthDataModalForClient());
        dispatch(clientReducerActions.setAuthLink(null));
    };

    useEffect(() => {
        if (clientReducer.deleteAuthDataErrorMessage) {
            setConnectedAuthErrorForClient(clientReducer.deleteAuthDataErrorMessage);
        } else if (clientReducer.editAuthDataErrorMessage) {
            setConnectedAuthErrorForClient(clientReducer.editAuthDataErrorMessage);
        } else if (clientReducer.prepareAuthDataOnboardingErrorMessage) {
            setConnectedAuthErrorForClient(clientReducer.prepareAuthDataOnboardingErrorMessage);
        } else {
            setConnectedAuthErrorForClient(null);
        }
    }, [
        clientReducer.deleteAuthDataErrorMessage,
        clientReducer.editAuthDataErrorMessage,
        clientReducer.prepareAuthDataOnboardingErrorMessage,
    ]);

    const isPaypalSetupState = useMemo(() => {
        return (
            clientReducer.editConnectedAuthData &&
            clientReducer.editConnectedAuthData.type === AuthDataType.PAYPAL.identifier &&
            clientReducer.editConnectedAuthData.status === AuthDataStatus.SETUP
        );
    }, [clientReducer.editConnectedAuthData]);

    return (
        <Modal3Options
            isOpen={clientReducer.editConnectedAuthDataModalForClient}
            isLoading={
                clientReducer.isEditAuthDataLoading ||
                clientReducer.prepareAuthDataOnboardingLoading ||
                clientReducer.isDeleteAuthDataLoading
            }
            disabled={
                clientReducer.isEditAuthDataLoading ||
                clientReducer.isLoading ||
                clientReducer.isDeleteAuthDataLoading ||
                !clientReducer.editConnectedAuthData.type ||
                (clientReducer.editConnectedAuthDataMode === Modes.CREATE &&
                    EXTERNAL_AUTH_CONNECTIONS.includes(clientReducer.editConnectedAuthData.type) &&
                    !clientReducer.authLink)
            }
            title={
                clientReducer.editConnectedAuthDataMode === Modes.CREATE
                    ? "Verbindung erstellen"
                    : "Verbindung bearbeiten"
            }
            primaryButtonText={
                clientReducer.editConnectedAuthDataMode === Modes.CREATE &&
                EXTERNAL_AUTH_CONNECTIONS.includes(clientReducer.editConnectedAuthData.type)
                    ? "Verbindung einrichten"
                    : isPaypalSetupState
                      ? "Neu verbinden"
                      : "Speichern"
            }
            primaryButtonColor={isPaypalSetupState ? "warning" : "primary"}
            toggleModal={cancelEditConnectedAuthData}
            handlePrimarySubmit={
                clientReducer.editConnectedAuthDataMode === Modes.CREATE &&
                EXTERNAL_AUTH_CONNECTIONS.includes(clientReducer.editConnectedAuthData.type)
                    ? () => (window.location.href = clientReducer.authLink)
                    : clientReducer.editConnectedAuthDataMode === Modes.CREATE &&
                        !EXTERNAL_AUTH_CONNECTIONS.includes(clientReducer.editConnectedAuthData.type)
                      ? () => dispatch(submitEditConnectedAuthData(clientReducer))
                      : isPaypalSetupState
                        ? () =>
                              dispatch(
                                  prepareAuthDataOnboarding(clientReducer.editConnectedAuthData.type, {
                                      externalUUID: clientReducer.editConnectedAuthData.clientUUID,
                                  })
                              )
                                  .then((response) => {
                                      if (response?.authLink) {
                                          window.location.href = response.authLink;
                                      }
                                  })
                                  .catch((error) => {
                                      // Error is already handled via Redux state/prepareAuthDataOnboardingErrorMessage
                                      // Catch prevents unhandled promise rejection in console
                                  })
                        : () => dispatch(updateConnectedAuthDataForClient(clientReducer.editConnectedAuthData))
            }
            secondaryIsDelete
            handleSecondarySubmit={() =>
                dispatch(deleteConnectedAuthDataForClient(clientReducer.editConnectedAuthData))
            }
            hidePrimaryOption={
                clientReducer.editConnectedAuthData.type === AuthDataType.PAYPAL.identifier &&
                clientReducer.editConnectedAuthData.status === AuthDataStatus.SETUP
                    ? false
                    : EXTERNAL_AUTH_CONNECTIONS.includes(clientReducer.editConnectedAuthData.type) &&
                      clientReducer.editConnectedAuthDataMode !== Modes.CREATE
            }
            hideSecondaryOption={clientReducer.editConnectedAuthDataMode === Modes.CREATE}
            errorMessage={connectedAuthErrorForClient}
            /* The 3-column type grid only shows before a connection type is chosen - once it's chosen
               (always true when editing) ConnectedAuthDataInput collapses to a single row plus the
               credential form, and lg leaves that mostly empty. */
            size={clientReducer.editConnectedAuthData.type ? "md" : "lg"}
            submitAndToggle={false}
            buttonCyData="add-connected-auth-data-button"
        >
            <ConnectedAuthDataInput
                handleConnectedAuthDataChange={props.handleConnectedAuthDataChange}
                clearWhiteSpaces={props.clearWhitespaces}
                setConnectedAuthErrorForClient={setConnectedAuthErrorForClient}
                handleFileUpload={props.handleFileUpload}
                disabled={props.disabled}
            />
        </Modal3Options>
    );
}
